export const appColors = {

  primaryRed: '#ff684a',
  primaryGreen: '#05a380',
  primaryBlue: '#00a3cc',
  brandBlue: '#007a99',
  orange: '#007a99',
  teal: '#008eb3'
};

export const greenPalette = [
  '#07a481',
  '#0aa582',
  '#0ca583',
  '#0ea684',
  '#11a786',
  '#13a887',
  '#15a888',
  '#18a989',
  '#1aaa8a',
  '#1dab8b',
  '#1fab8c',
  '#21ac8d',
  '#24ad8f',
  '#26ae90',
  '#28af91',
  '#2baf92',
  '#2db093',
  '#2fb194',
  '#32b295',
  '#34b296',
  '#36b398',
  '#39b499',
  '#3bb59a',
  '#3db59b',
  '#40b69c',
  '#42b79d',
  '#44b89e',
  '#47b99f',
  '#49b9a0',
  '#4cbaa2',
  '#4ebba3',
  '#50bca4',
  '#53bca5',
  '#55bda6',
  '#57bea7',
  '#5abfa8',
  '#5cbfa9',
  '#5ec0ab',
  '#61c1ac',
  '#63c2ad',
  '#65c3ae',
  '#68c3af',
  '#6ac4b0',
  '#6cc5b1',
  '#6fc6b2',
  '#71c6b4',
  '#73c7b5',
  '#76c8b6',
  '#78c9b7',
  '#7bcab8',
  '#7dcab9',
  '#7fcbba',
  '#82ccbb',
  '#84cdbc',
  '#86cdbe',
  '#89cebf',
  '#8bcfc0',
  '#8dd0c1',
  '#90d0c2',
  '#92d1c3',
  '#94d2c4',
  '#97d3c5',
  '#99d4c7',
  '#9bd4c8',
  '#9ed5c9',
  '#a0d6ca',
  '#a2d7cb',
  '#a5d7cc',
  '#a7d8cd',
  '#aad9ce',
  '#acdad0',
  '#aedad1',
  '#b1dbd2',
  '#b3dcd3',
  '#b5ddd4',
  '#b8ded5',
  '#baded6',
  '#bcdfd7',
  '#bfe0d8',
  '#c1e1da',
  '#c3e1db',
  '#c6e2dc',
  '#c8e3dd',
  '#cae4de',
  '#cde4df',
  '#cfe5e0',
  '#d1e6e1',
  '#d4e7e3',
  '#d6e8e4',
  '#d9e8e5',
  '#dbe9e6',
  '#ddeae7',
  '#e0ebe8',
  '#e2ebe9',
  '#e4ecea',
  '#e7edec',
  '#e9eeed',
  '#ebeeee',
  '#eeefef',
  '#f0f0f0',
];

export const orangePalette = [
  '#dba72c',
  '#dba72e',
  '#dca830',
  '#dca932',
  '#dcaa34',
  '#dcaa36',
  '#dcab38',
  '#ddac3a',
  '#ddad3c',
  '#ddad3e',
  '#ddae40',
  '#deaf42',
  '#deb044',
  '#deb046',
  '#deb148',
  '#deb24a',
  '#dfb34c',
  '#dfb34e',
  '#dfb450',
  '#dfb552',
  '#dfb654',
  '#e0b656',
  '#e0b758',
  '#e0b85a',
  '#e0b95c',
  '#e0b95d',
  '#e1ba5f',
  '#e1bb61',
  '#e1bb63',
  '#e1bc65',
  '#e2bd67',
  '#e2be69',
  '#e2be6b',
  '#e2bf6d',
  '#e2c06f',
  '#e3c171',
  '#e3c173',
  '#e3c275',
  '#e3c377',
  '#e3c479',
  '#e4c47b',
  '#e4c57d',
  '#e4c67f',
  '#e4c781',
  '#e4c783',
  '#e5c885',
  '#e5c987',
  '#e5ca89',
  '#e5ca8b',
  '#e6cb8d',
  '#e6cc8f',
  '#e6cc91',
  '#e6cd93',
  '#e6ce95',
  '#e7cf97',
  '#e7cf99',
  '#e7d09b',
  '#e7d19d',
  '#e7d29f',
  '#e8d2a1',
  '#e8d3a3',
  '#e8d4a5',
  '#e8d5a7',
  '#e8d5a9',
  '#e9d6ab',
  '#e9d7ad',
  '#e9d8af',
  '#e9d8b1',
  '#e9d9b3',
  '#eadab5',
  '#eadbb7',
  '#eadbb9',
  '#eadcbb',
  '#ebddbd',
  '#ebdebf',
  '#ebdec0',
  '#ebdfc2',
  '#ebe0c4',
  '#ece0c6',
  '#ece1c8',
  '#ece2ca',
  '#ece3cc',
  '#ece3ce',
  '#ede4d0',
  '#ede5d2',
  '#ede6d4',
  '#ede6d6',
  '#ede7d8',
  '#eee8da',
  '#eee9dc',
  '#eee9de',
  '#eeeae0',
  '#efebe2',
  '#efece4',
  '#efece6',
  '#efede8',
  '#efeeea',
  '#f0efec',
  '#f0efee',
  '#f0f0f0',
];

export const bluePalette = [
  '#027b9a',
  '#057c9b',
  '#077e9c',
  '#0a7f9c',
  '#0c809d',
  '#0e819e',
  '#11829f',
  '#1383a0',
  '#1685a1',
  '#1886a2',
  '#1a87a3',
  '#1d88a3',
  '#1f89a4',
  '#228ba5',
  '#248ca6',
  '#268da7',
  '#298ea8',
  '#2b8fa9',
  '#2e90aa',
  '#3092aa',
  '#3293ab',
  '#3594ac',
  '#3795ad',
  '#3a96ae',
  '#3c98af',
  '#3e99b0',
  '#419ab0',
  '#439bb1',
  '#469cb2',
  '#489db3',
  '#4a9fb4',
  '#4da0b5',
  '#4fa1b6',
  '#52a2b7',
  '#54a3b7',
  '#56a4b8',
  '#59a6b9',
  '#5ba7ba',
  '#5ea8bb',
  '#60a9bc',
  '#62aabd',
  '#65acbe',
  '#67adbe',
  '#6aaebf',
  '#6cafc0',
  '#6eb0c1',
  '#71b1c2',
  '#73b3c3',
  '#76b4c4',
  '#78b5c5',
  '#7ab6c5',
  '#7db7c6',
  '#7fb9c7',
  '#82bac8',
  '#84bbc9',
  '#86bcca',
  '#89bdcb',
  '#8bbecb',
  '#8ec0cc',
  '#90c1cd',
  '#92c2ce',
  '#95c3cf',
  '#97c4d0',
  '#9ac6d1',
  '#9cc7d2',
  '#9ec8d2',
  '#a1c9d3',
  '#a3cad4',
  '#a6cbd5',
  '#a8cdd6',
  '#aaced7',
  '#adcfd8',
  '#afd0d9',
  '#b2d1d9',
  '#b4d3da',
  '#b6d4db',
  '#b9d5dc',
  '#bbd6dd',
  '#bed7de',
  '#c0d8df',
  '#c2dadf',
  '#c5dbe0',
  '#c7dce1',
  '#cadde2',
  '#ccdee3',
  '#cedfe4',
  '#d1e1e5',
  '#d3e2e6',
  '#d6e3e6',
  '#d8e4e7',
  '#dae5e8',
  '#dde7e9',
  '#dfe8ea',
  '#e2e9eb',
  '#e4eaec',
  '#e6ebed',
  '#e9eced',
  '#ebeeee',
  '#eeefef',
  '#f0f0f0',
];

export const redPalette = [
  '#ff7156',
  '#ff7357',
  '#ff7459',
  '#fe755a',
  '#fe765c',
  '#fe785d',
  '#fe795f',
  '#fe7a60',
  '#fe7c62',
  '#fe7d64',
  '#fd7e65',
  '#fd7f67',
  '#fd8168',
  '#fd826a',
  '#fd836b',
  '#fd846d',
  '#fc866f',
  '#fc8770',
  '#fc8872',
  '#fc8a73',
  '#fc8b75',
  '#fc8c76',
  '#fc8d78',
  '#fb8f79',
  '#fb907b',
  '#fb917d',
  '#fb937e',
  '#fb9480',
  '#fb9581',
  '#fb9683',
  '#fa9884',
  '#fa9986',
  '#fa9a87',
  '#fa9c89',
  '#fa9d8b',
  '#fa9e8c',
  '#f99f8e',
  '#f9a18f',
  '#f9a291',
  '#f9a392',
  '#f9a494',
  '#f9a696',
  '#f9a797',
  '#f8a899',
  '#f8aa9a',
  '#f8ab9c',
  '#f8ac9d',
  '#f8ad9f',
  '#f8afa0',
  '#f8b0a2',
  '#f7b1a4',
  '#f7b3a5',
  '#f7b4a7',
  '#f7b5a8',
  '#f7b6aa',
  '#f7b8ab',
  '#f6b9ad',
  '#f6baae',
  '#f6bcb0',
  '#f6bdb2',
  '#f6beb3',
  '#f6bfb5',
  '#f6c1b6',
  '#f5c2b8',
  '#f5c3b9',
  '#f5c4bb',
  '#f5c6bd',
  '#f5c7be',
  '#f5c8c0',
  '#f5cac1',
  '#f4cbc3',
  '#f4ccc4',
  '#f4cdc6',
  '#f4cfc7',
  '#f4d0c9',
  '#f4d1cb',
  '#f3d3cc',
  '#f3d4ce',
  '#f3d5cf',
  '#f3d6d1',
  '#f3d8d2',
  '#f3d9d4',
  '#f3dad5',
  '#f2dcd7',
  '#f2ddd9',
  '#f2deda',
  '#f2dfdc',
  '#f2e1dd',
  '#f2e2df',
  '#f2e3e0',
  '#f1e4e2',
  '#f1e6e4',
  '#f1e7e5',
  '#f1e8e7',
  '#f1eae8',
  '#f1ebea',
  '#f0eceb',
  '#f0eded',
  '#f0efee',
  '#f0f0f0',
];

export function getRandomColor() {
  const palettes = [
    greenPalette,
    orangePalette,
    bluePalette,
    redPalette
  ];

  const palette = palettes[Math.floor(Math.random() * 4)];

  return palette[Math.floor(Math.random() * palette.length - 1)];
}
